
<div class="background-container">
  <form [formGroup]="passwordForm">
    <mpro-text-input [isPassword]="true" [title]="labels ? 'Password' : undefined" [placeholder]="passwordPlaceholder"
      formControlName="password">
    </mpro-text-input>
    <mpro-text-input [isPassword]="true" [title]="labels ? 'Repeat the password' : undefined"
      [placeholder]="confirmPasswordPlaceholder" [inputState]="getPasswordMatchMessage() ? 'error' : 'default'"
      [errorMsg]="getPasswordMatchMessage()" formControlName="passwordConfirm">
    </mpro-text-input>
    <div class="password-strength-container" style="transform: scale(0.8); transform-origin: top left;">
      <mpro-password-strength 
        [currentPassword]="passwordForm.get('password')?.value"
        (passwordStrengthChange)="onPasswordStrengthChange($event)">
      </mpro-password-strength>
    </div>
  </form>
</div>
